// extracted by mini-css-extract-plugin
export default {"breakpoint":"1000"};